import React, { createContext, useState } from "react";

const OrderContext2 = createContext({
  checkUpdateButton: false,
  setCheckUpdateButton: () => {},
  checkSent: 0,
  setCheckSent: () => {},
  sentShipmentSuggestion: [],
  setSentShipmentSuggestion: () => {},
  disableAfterSelect: false,
  setDisableAfterSelect: () => {},
});

export const ContextProvider2 = (props) => {
  const [checkUpdateButton, setCheckUpdateButton] = useState(false);
  const [checkSent, setCheckSent] = useState(0);
  const [sentShipmentSuggestion, setSentShipmentSuggestion] = useState([]); // for showing sentSuggestion in factory shipment
  const [disableAfterSelect, setDisableAfterSelect] = useState(false);

  return (
    <OrderContext2.Provider
      value={{
        checkUpdateButton,
        setCheckUpdateButton, // Pass the custom handler
        checkSent,
        setCheckSent,
        sentShipmentSuggestion,
        setSentShipmentSuggestion,
        disableAfterSelect,
        setDisableAfterSelect
      }}
    >
      {props.children}
    </OrderContext2.Provider>
  );
};

export default OrderContext2;
